VLW.Compenents.CarteVinTouch = class extends VLW.classBase {
	constructor(elt) {
		
		super();
		
		
		this.lockBody();
		this.ctrl 		= elt;
		this.elt       = elt.svg;
		this.input     = {dragStartX: 0, dragStartY: 0, dragX: 0, dragY: 0, dragDX: 0, dragDY: 0, dragDistance: 0, dragging: false};
		this.i         = 0;
		this.elt.input = {startX: 0, startY: 0};
		this.touchObj  = document.querySelector(".carteVin");
		this.touchObj.addEventListener('touchmove'	, this.on_TouchMove);
		this.touchObj.addEventListener('touchend'		, this.on_TouchEnd);
		this.touchObj.addEventListener('touchstart'	, this.on_TouchStart);
		this.icos = document.querySelectorAll(".ui-svg-marker-ico");
		[...this.icos].forEach((elt)=>elt.addEventListener("click",this.onClickIco));
	}

	onClickIco(e) {
		e.currentTarget.parentNode.classList.toggle("visible");
	}
	lockBody(){
		document.body.classList.add("lockBody");
	}
	unlockBody(){
		document.body.classList.remove("lockBody");
	}

	on_TouchEnd(event) {
		/*
		if(event.cancelable ) {
			event.preventDefault();
		}
		
		 */
		this.input.dragging = false;
		this.i              = 0;
		this.ctrl.repaintMap();
	}

	on_TouchMove(event) {
		/*
		if(event.cancelable) {
			event.preventDefault();
			event.stopPropagation();
		}
		*/
		this.i++;
		if (this.input.dragging === false) {
			let  style             = window.getComputedStyle(this.elt);
			let  matrix            = new WebKitCSSMatrix(style.webkitTransform);
			this.elt.input        = {startX: matrix.m41, startY: matrix.m42};
			this.input.dragStartX = this.input.dragX = event.touches[0].pageX;
			this.input.dragStartY = this.input.dragY = event.touches[0].pageY;
			this.input.dragDistance = 0;
			this.input.dragging     = true;
		} else {
			this.input.dragDX = event.touches[0].pageX - this.input.dragStartX;
			this.input.dragDY = event.touches[0].pageY - this.input.dragStartY;
			if (event.touches.length === 1) {
				this.ctrl.setXY(this.elt.input.startX + this.input.dragDX, this.elt.input.startY + this.input.dragDY);
			}
			if (event.touches.length === 2 && this.i % 2 === 1) {
				let a            = {x: event.touches[0].pageX, y: event.touches[0].pageY};
				let b            = {x: event.touches[1].pageX, y: event.touches[1].pageY};
				let currDistance = Math.sqrt(Math.pow(b.y - a.y, 2) + Math.pow(b.x - a.x, 2)).toFixed(0);
				
				this.ctrl.onMouseMove({clientX: (event.touches[1].pageX + event.touches[0].pageX) * .5, clientY: (event.touches[1].pageY + event.touches[0].pageY) * .5});
				this.ctrl.zoomDelta(((currDistance > this.input.dragDistance) ? 1 : -1));
				this.input.dragDistance = currDistance;
			}
		}
	}

	on_TouchStart(event) {
		event.preventDefault();
		TweenMax.set(this.ctrl.svg, {force3D: true});
		[...this.icos].forEach((elt)=>elt.parentNode.classList.remove("visible"));
	}

	instanceClean() {
		this.unlockBody();
		[...this.icos].forEach((elt)=>elt.removeEventListener("click",this.onClickIco));
		if (this.touchObj) {
			this.touchObj.removeEventListener('touchstart'	, this.on_TouchStart);
			this.touchObj.removeEventListener('touchend'	, this.on_TouchEnd);
			this.touchObj.removeEventListener('touchmove'	, this.on_TouchMove);
			this.touchObj = null;
		}
		super.instanceClean();
	}

};
